var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0171B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.301,56.615c13.786,0,25-11.215,25-25s-11.215-25-25-25c-13.785,0-25,11.215-25,25S34.516,56.615,48.301,56.615z M48.301,14.615c9.375,0,17,7.626,17,17s-7.626,17-17,17c-9.374,0-17-7.626-17-17S38.927,14.615,48.301,14.615z M96,89.75h-8 c0-9.925-8.075-18-18-18H26c-9.925,0-18,8.075-18,18H0c0-14.337,11.664-26,26-26h44C84.337,63.75,96,75.413,96,89.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/userBlue.8024d28e4f222f64c2ffe0a24cb956c1.svg";
export { ForwardRef as ReactComponent };